import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import './MyReferralCode.css';

/* A player's own invite code (PLG / HT), shown on /refer and on Home. A friend opens the link
   (tornea.app/friend/<code>) and claims a spot on the early list for the next edition — first to
   hear when it opens, so the lowest price. No discount is promised, so none is mentioned.
   `code` is the API's {code, link, claims}. `compact` = the Home strip. */
const MyReferralCode = ({ code, brand, compact = false }) => {
  const { t } = useTranslation('common');
  const [copied, setCopied] = useState(false);
  if (!code?.code) return null;

  const text = t('referCodeShareText', { code: code.code, brand: brand || '' });

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${text} ${code.link}`);
      setCopied(true); setTimeout(() => setCopied(false), 2200);
    } catch { window.prompt(t('copyLink'), code.link); }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: code.code, text, url: code.link }); return; } catch { /* fall through */ }
    }
    copy();
  };
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`${text} ${code.link}`)}`;

  return (
    <div className={`my-code${compact ? ' my-code--compact' : ''}`}>
      <div className="my-code__label">{t('referCodeLabel')}</div>
      <div className="my-code__code">{code.code}</div>
      {!compact && <p className="my-code__body">{t('referCodeBody')}</p>}
      {code.claims > 0 && <div className="my-code__claims">{t('referCodeClaims', { count: code.claims })}</div>}
      <div className="my-code__actions">
        <button type="button" className="home-pill" onClick={share}>
          <Icon name="share-square" /> <span>{t('shareLink')}</span>
        </button>
        <a className="home-pill" href={whatsapp} target="_blank" rel="noreferrer">
          <Icon name="whatsapp" pack="brands" /> <span>WhatsApp</span>
        </a>
        <button type="button" className="home-pill" onClick={copy}>
          <Icon name="copy" /> <span>{copied ? t('copied', { defaultValue: 'Copied!' }) : t('referCodeCopy')}</span>
        </button>
      </div>
    </div>
  );
};

export default MyReferralCode;
